export enum AmplifyAuthStatus {
  CONFIGURING = "configuring",
  AUTHENTICATED = "authenticated",
  UNAUTHENTICATED = "unauthenticated",
}
